import React, { useEffect, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Input from '../../../components/Form/Input';
import Button from '../../../components/Button';
import { nextAction, checkinAction } from '../../../saga/actions/workflow';
import IconID from '../../../assets/images/id-front.svg';
import { getNextUrl, getCheckinUrl } from '../BorrowStep/url';
import { unmaskSSN, maskSSN3 } from '../../../utils/masks';
import { getHTTPErrorMessage } from '../../../utils/fetch';

const Welcome = (props) => {
  const { workflow } = props;
  const { search } = useLocation();
  const key = new URLSearchParams(search).get('key');
  const history = useHistory();
  const errorMsg = useMemo(() => getHTTPErrorMessage(workflow.error), [workflow]);

  // get functions to build form with useForm() hook
  const hookForm = useForm();
  const { handleSubmit } = hookForm;

  useEffect(() => {
    checkinAction({
      url: getCheckinUrl(key),
      method: 'PUT',
      data: {},
      success: (response) => {
        localStorage.setItem('key', response.key);
      },
      fail: () => {},
    });
  }, [key]); // component didmount

  const validateSSN = (input) => {
    if (!input) {
      return 'The input field is required';
    }

    return unmaskSSN(input).length < 4
      ? 'SSN is not valid'
      : true;
  };

  const onSubmit = (data) => {
    props.nextAction({
      url: getNextUrl(),
      method: 'PUT',
      data: {
        SsnLast4Digits: data.code,
      },
      success: (response) => {
        console.log('response ---> ', response);
        history.push(`/main?key=${key}`);
      },
      fail: () => {},
    });
    return false;
  };

  return (
    <div className="flex flex-col h-screen justify-center items-center">
      <img src={IconID} alt="ID Verification" className="mb-3" />
      <form onSubmit={handleSubmit(onSubmit)} className="p-[10px] flex flex-col max-w-[500px] w-full items-center">
        <h2 className="text-[#2b445f] text-center mt-[25px] text-[26px] leading-[1.2] font-[600] font-apple text-[2rem]">
          Please enter the last 4 digits of your SSN to continue
        </h2>
        <div className="flex flex-col justify-center items-center bg-white shadow-ssn-verification rounded-[12px] mt-[35px] p-[25px] pt-[12px] max-w-[410px] w-full">
          <Input
            autoFocus
            name="code"
            placeholder="Last 4 Digits of Your SSN"
            label=""
            className="mt-0 w-full"
            hookForm={hookForm}
            isMasked={maskSSN3}
            validate={validateSSN}
          />
          <Button isLoading={props.workflow.isLoading} type="submit" className="w-full h-[46px] leading-[16px] mt-[13px]">Continue</Button>
        </div>
        {errorMsg && <div className="mt-3 mb-3 text-[#d71f28] text-xs">{errorMsg}</div>}
      </form>
    </div>
  );
};

Welcome.propTypes = {
  workflow: PropTypes.object.isRequired,
  nextAction: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => ({
      workflow: state.workflow,
    }),
    {
      nextAction,
      checkinAction,
    }
  )
)(Welcome);
